var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgRememberBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H1C0.447715 0 0 0.447716 0 1V16.8258C0 17.6801 1.00212 18.141 1.65079 17.585L5.93492 13.9129C5.97237 13.8808 6.02763 13.8808 6.06508 13.9129L10.3492 17.585C10.9979 18.141 12 17.6801 12 16.8258V6.5C12 5.94772 11.5523 5.5 11 5.5C10.4477 5.5 10 5.94772 10 6.5V14.6516L7.36666 12.3944C6.58024 11.7203 5.41977 11.7203 4.63334 12.3944L2 14.6516V2H11C11.5523 2 12 1.55228 12 1C12 0.447715 11.5523 0 11 0Z",
    fill: "#292927"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRememberBadge);
export default __webpack_public_path__ + "static/media/remember-badge.a2f1f26dfc503c85cedb3de9c9684231.svg";
export { ForwardRef as ReactComponent };